import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
} from "reactstrap";
import options from "../data/organizationimg";
const ReportButton = ({
  formik,
  reportStatus,
  setReportStatus,
  setActiveStep,
  selectedOrganizations,
  setSelectedOrganization,
}) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [waitingForApprovalVisible, setWaitingForApprovalVisible] =
    useState(true);

  const openModal = () => {
    setSelectedOptions([...selectedOrganizations]);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = () => {
    setReportStatus("submitted");
    setActiveStep(3);
    console.log("Submitting report...");
    console.log(
      "Selected Options:",
      options.filter((_, index) => selectedOptions[index])
    );

    handleCloseModal();
  };
  // const handleCheckboxChange = (index) => {
  //   setSelectedOptions((prevSelected) => {
  //     const isSelected = prevSelected.includes(index);

  //     let updatedSelected;

  //     if (isSelected) {
  //       // If already selected, remove it
  //       updatedSelected = prevSelected.filter((item) => item !== index);
  //     } else {
  //       // If not selected, add it
  //       updatedSelected = [...prevSelected, index];
  //     }

  //     // Notify the parent component about the selected organizations using selectedOrganizations prop
  //     setSelectedOrganization(updatedSelected);

  //     return updatedSelected;
  //   });
  // };

  const handleCheckboxChange = (index) => {
    setSelectedOptions((prevSelected) => {
      const updatedSelected = [...prevSelected];
      updatedSelected[index] = !updatedSelected[index];

      // Notify the parent component about the selected organizations using selectedOrganizations prop
      setSelectedOrganization(updatedSelected);

      return updatedSelected;
    });
  };

  // useEffect(() => {
  //   console.log("Received Selected Organizations:", selectedOrganizations);
  // }, [selectedOrganizations]);

  // useEffect(() => {
  //   // Update selectedOptions based on the reportStatus
  //   const updatedSelectedOptions = options.map((option) => {
  //     return {
  //       ...option,
  //       selected: reportStatus === "submitted" || reportStatus === "approved",
  //     };
  //   });
  //   setSelectedOptions(updatedSelectedOptions);
  // }, [reportStatus]);

  return (
    <div>
      {reportStatus === "new report" && (
        <Row>
          <Col lg={6}>
            <Row>
              <Col lg={4}>
                <Button
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                >
                  Import Data
                </Button>
              </Col>
              <Col lg={4} className="text-end">
                <Button
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                >
                  Clear Data
                </Button>
              </Col>
            </Row>
          </Col>
          <Col lg={6} className="text-end">
            <Button
              size="lg"
              className="ms-auto p-2 border-white"
              color="danger"
              type="submit"
              style={{ width: "30%" }}
              onClick={() => {
                setReportStatus("drafted");
                setActiveStep(1);
              }}
            >
              Save as Draft
            </Button>
          </Col>
        </Row>
      )}
      {reportStatus === "drafted" && (
        <Row>
          <Col lg={6}>
            <Row>
              <Col lg={4}>
                <Button
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                >
                  Delete
                </Button>
              </Col>
              <Col lg={4} className="d-flex ">
                <Button
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                >
                  Clear Data
                </Button>
              </Col>
              <Col lg={4} className="d-flex ">
                <Button
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                >
                  Save as PDF
                </Button>
              </Col>
            </Row>
          </Col>

          <Col lg={6}>
            <Row>
              <div className="d-flex justify-content-end gap-4">
                <Button
                  size="lg"
                  className="ms-auto p-2 border-white"
                  color="danger"
                  style={{ width: "30%" }}
                >
                  Save as Draft
                </Button>

                <Button
                  size="lg"
                  color="warning"
                  className="btn p-2"
                  style={{ width: "30%" }}
                  onClick={() => {
                    setReportStatus("initiated");
                    setActiveStep(2);
                  }}
                >
                  Initiate
                </Button>
              </div>
            </Row>
          </Col>
        </Row>
      )}
      {reportStatus === "initiated" && (
        <Row className="">
          {/* Column for Import Excel File and Clear Data buttons */}
          <Col lg={6}>
            <Row>
              <Col lg={4}>
                {/* <Button block className="ms-2 btn-primary">Import Excel File</Button> */}

                <Button
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                >
                  Delete
                </Button>
              </Col>
              <Col lg={4} className="d-flex ">
                <Button
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                >
                  Clear Data
                </Button>
              </Col>
              <Col lg={4} className="d-flex ">
                <Button
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                >
                  Save as PDF
                </Button>
              </Col>
            </Row>
          </Col>

          <Col lg={6}>
            <Row>
              <div className="d-flex justify-content-end gap-4">
                <Button
                  size="lg"
                  color="danger"
                  className="btn p-2"
                  style={{ width: "30%" }}
                >
                  Save as Draft
                </Button>

                <Button
                  size="lg"
                  color="info"
                  className="btn p-2"
                  onClick={openModal}
                  style={{ width: "30%" }}
                >
                  Submit
                </Button>
              </div>
            </Row>
          </Col>
        </Row>
      )}

      {reportStatus === "submitted" && (
        <Row className="">
          {/* Column for Import Excel File and Clear Data buttons */}
          <Col lg={6}>
            <Row>
              {/* <Col lg={4}>
                <Button
                  block
                  outline
                  size="lg"
                  color="primary"
                  className="btn p-2  waves-effect w-100 "
                >
                  Delete
                </Button>
              </Col> */}
              <Col lg={4} className="d-flex ">
                <Button
                  block
                  outline
                  size="lg"
                  color="primary"
                  className="btn  p-2 w-100 ms-1"
                >
                  Save as PDF
                </Button>
              </Col>
            </Row>
          </Col>

          <Col lg={6}>
            <Row>
              <div className="d-flex justify-content-end">
                <div
                  className="btn p-2 wave-effect w-80 ms-4 fs-18"
                  style={{ height: "100%", color: "green" }}
                >
                  Waiting for acknowledgement
                </div>

                {/* <Button
                  outline
                  size="lg"
                  color="success"
                  className="btn  p-2 wave-efffect w-80 ms-4"
                  style={{ height: "100%" }}
                  onClick={() => {
                    setReportStatus("approved");
                    setActiveStep(4);
                  }}
                >
                  Acknowedge
                </Button> */}
              </div>
            </Row>
          </Col>
        </Row>
      )}
      {reportStatus === "approved" && (
        <Row className="">
          {/* Column for Import Excel File and Clear Data buttons */}
          <Col lg={6}>
            <Row>
              <Col lg={4}>
                {/* <Button block className="ms-2 btn-primary">Import Excel File</Button> */}
                <Button
                  block
                  outline
                  size="lg"
                  color="primary"
                  className="btn  p-2 waves-effect w-100 "
                >
                  Delete
                </Button>
              </Col>
              <Col lg={4} className="d-flex ">
                <Button
                  block
                  outline
                  size="lg"
                  color="primary"
                  className="btn p-2 w-100 ms-1"
                >
                  Save as PDF
                </Button>
              </Col>
            </Row>
          </Col>

          <Col lg={6}>
            <Row>
              <div className="d-flex justify-content-end">
                {waitingForApprovalVisible && (
                  <div
                    className={`p-2 wave-effect w-80 text-warning fw-bold`}
                    style={{ height: "100%" }}
                  >
                    Waiting for approval
                  </div>
                )}
                <Button
                  outline
                  size="lg"
                  color="success"
                  className="btn btn-outline-success wave-efffect w-40 ms-4"
                  style={{ height: "100%" }}
                  onClick={() => {
                    setWaitingForApprovalVisible(false); // Hide "Waiting for approval" message
                    setActiveStep(5);

                    setTimeout(() => {
                      navigate("/report"); // Redirect to the 'report' page
                    }, 300);
                  }}
                >
                  Approve
                </Button>
              </div>
            </Row>
          </Col>
        </Row>
      )}

      {reportStatus === "approval" && (
        <Row className="">
          {/* Column for Import Excel File and Clear Data buttons */}
          <Col lg={6}>
            <Row>
              <Col lg={4}>
                {/* <Button block className="ms-2 btn-primary">Import Excel File</Button> */}
                <Button
                  block
                  outline
                  size="lg"
                  color="primary"
                  className="btn  waves-effect w-100 "
                >
                  Delete
                </Button>
              </Col>
              <Col lg={4} className="d-flex ">
                <Button
                  block
                  outline
                  size="lg"
                  color="primary"
                  className="btn  w-100 ms-1"
                >
                  Save as PDF
                </Button>
              </Col>
            </Row>
          </Col>

          {/* <Col lg={6}>
            <Row>
              <div className="d-flex justify-content-end">
               
              </div>
            </Row>
          </Col> */}
        </Row>
      )}

      <Modal isOpen={isModalOpen} toggle={handleCloseModal}>
        <ModalHeader
          toggle={handleCloseModal}
          className="text-center"
        ></ModalHeader>
        <ModalBody>
          <Container>
            <Row>
              <Col xs={12} className="text-center">
                <p>
                  <strong>
                    Select affiliated organization to submit report
                  </strong>
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center mt-2">
              {options.map((option, index) => (
                <Col xs={6} md={3} key={index} className="text-center mb-3">
                  <div
                    className="position-relative image-container px-auto border rounded"
                    style={{ borderWidth: "3px", height: "100%" }}
                  >
                    <div className="form-check form-check-success mb-3">
                      <Input
                        className="form-check-input custom-rounded position-absolute end-0 top-0 mt-2 me-2"
                        type="checkbox"
                        id={`image${index + 1}`}
                        checked={selectedOptions[index] || false}
                        onChange={() => handleCheckboxChange(index)}
                      />

                      <Label
                        className="form-check-label"
                        htmlFor={`image${index + 1}`}
                      ></Label>
                    </div>
                    <div className="img-container mt-2 mx-auto">
                      <img
                        src={option.image}
                        className="img-fluid rounded"
                        alt={`Option ${index + 1}`}
                        style={{
                          width: "50%",
                          height: "auto",
                          margin: "auto",
                        }}
                      />
                      <div className="text-below-image mt-2 px-2">
                        <p>{option.label}</p>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            <Row className="d-flex justify-content-center mt-2">
              <Col>
                <div className="d-flex justify-content-center">
                  <Button
                    size="lg"
                    color="info"
                    className="btn p-2"
                    onClick={handleSubmit}
                    style={{ width: "60%" }}
                  >
                    Submit Report
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ReportButton;
